import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";

// Icons
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
// Components
import CheckDetailsTable from "./CheckDetailsTable"; //reused table component
import PurchaseOrderAllocationTable from "../Purchases/PurchaseOrderAllocationTable";
import PDFCheckViewReference from '../Purchases/PDFCheckViewReference';
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";
//number format plugin
import numeral from "numeral";


const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
});

const CheckViewReference = () => {
	const { chkno, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState(null);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [checkDetails, setCheckDetails] = useState([]); //data to display in check table
	const [allocation, setAllocation] = useState([]); //data to display in allocation table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [notes, setNotes] = useState('');

	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const DownloadPdf = ( { date, payTo, cleared, printed, allocation, balance, checkTotal, itemsCheck, itemsAllocation, notes  } ) => {
		return (
		<PDFDownloadLink 
			document={
			<PDFCheckViewReference date={date} payTo={payTo} cleared={cleared} printed={printed} allocation={allocation} balance={balance} checkTotal={checkTotal} itemsCheck={itemsCheck} itemsAllocation={itemsAllocation} notes={notes} chkno={chkno} />} 
			fileName={"check-reference-"+chkno}>
			{({ loading }) => (loading ? 'loading...' : <Button variant="contained" color="primary">Print PDF</Button> )}
		</PDFDownloadLink>
		)
	}

	const data = async () => {
		// const po_details = await axios.get(process.env.REACT_APP_API_URL+'get_po_details_reference', {
		 await axios.get(process.env.REACT_APP_API_URL+'check_view_reference', {
			params:{
				chkno: chkno,
				jc_u_idno: branchidno
			}
		}).then((res) => {
			// console.log(res.data);
			setCheckDetails(res.data.data[2].check_details);
			setSupplierInfo(res.data.data[0].supplier_details);
			setShipTotal(res.data.data[0].supplier_details.shipping);
			setPoTotal(res.data.data[2].check_details[0].amount);
			// setGrandTotal(res.data.data[1].supplier_details.grand_total);
			setNotes(res.data.data[0].supplier_details.notes);
			setAllocation(res.data.data[1].allocations);
		}).catch((error) => {
			// console.log(error);
		});
	};	



	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceWalletIcon />
				</div>
				<NavLink to={"/account"}><h2 style={{color:"black"}}>Account</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/account/check-transaction-history"}><h2 style={{color:"black"}}>Check Transaction History</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Check View Reference #{chkno}</h2>
				{/* <h2>supplier id: {supid} - delivery_date: {delivery_date}</h2> test if param values were passed*/}
			</div>
		{supplierInfo ? (			<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={12} sm={8}>
								<div className={classes.subTitle}>
									Check View Reference
								</div>
								<div className={classes.title}>
									Check View Reference
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								{/* <PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/> */}
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								{
									allocation.length > 0 ? //Check if alocations not empty
									<DownloadPdf 
									date		= {supplierInfo.date_add || "Date"}
									payTo		= {supplierInfo.pay_to || "Pay To"}
									cleared		= {supplierInfo.cleared || "Cleared"}
									printed		= {supplierInfo.printed || "Printed"}
									allocation	= {supplierInfo.allocation || "Allocation"}
									balance		= {numeral(supplierInfo.balance).format('0,0.00')}
									checkTotal	= {numeral(poTotal).format('0,0.00')}
									itemsCheck 	= {checkDetails}
									itemsAllocation = {allocation}
									notes		= {notes || ''}
									/> : ''
								}
								{/* <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/> */}
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={1} className={classes.infoTitle}>
									Date: 
								</Grid>
								<Grid
									item
									xs={12} sm={11}
									className={classes.infoContent}
								>
									{supplierInfo.date_add || "Date"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={1} className={classes.infoTitle}>
									Pay To: 
								</Grid>
								<Grid
									item
									xs={12} sm={11}
									className={classes.infoContent}
								>
									{supplierInfo.pay_to || "Pay To"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={1} className={classes.infoTitle}>
									Cleared:
								</Grid>
								<Grid
									item
									xs={12} sm={11}
									className={classes.infoContent}
								>
									{supplierInfo.cleared || "Cleared"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={1} className={classes.infoTitle}>
									Printed:
								</Grid>
								<Grid
									item
									xs={12} sm={11}
									className={classes.infoContent}
								>
									{supplierInfo.printed || "Printed"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={1} className={classes.infoTitle}>
									Allocation:
								</Grid>
								<Grid
									item
									xs={12} sm={11}
									className={classes.infoContent}
								>
									{supplierInfo.allocation || "Allocation"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={1} className={classes.infoTitle}>
									Balance:
								</Grid>
								<Grid
									item
									xs={12} sm={11}
									className={classes.infoContent}
								>
									{numeral(supplierInfo.balance).format('0,0.00')}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderAllocationTable items={allocation} type={0} branchidno={branchidno}/>
						<div className={classes.miniTitle}>
									Check Details
						</div>
						<CheckDetailsTable items={checkDetails}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(poTotal).format('0,0.00')}	
									</div>
								</div>	
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
			</div>
		) : (<Preloader />)}

		</div>
	);
};

export default CheckViewReference;
